<br />
<img class="system-logo" src="assets/images/logos/logo_transparent.png" />
<br />
<h2 class="text-center">Change Password</h2>
<br />
<div class="change-password-container clearfix">
  @if (!hasExpired) {
    <form (ngSubmit)="onSubmit()" [formGroup]="changePasswordForm">
      <div class="row">
        <pcg-control-group
          [validations]="{ commonPassword: 'Pick a less common password.' }"
          class="col-sm-12"
          label="New Password"
          >
          <input pcgControlRef formControlName="password" type="password" class="form-control" />
        </pcg-control-group>
      </div>
      <div class="row">
        <pcg-control-group
          [validations]="{ passwordsNotEqual: 'Passwords do not match.' }"
          class="col-sm-12"
          label="Confirm New Password"
          >
          <input pcgControlRef formControlName="confirmPassword" type="password" class="form-control" />
        </pcg-control-group>
      </div>
      <button type="submit" class="btn btn-secondary btn-lg">Change Password</button>
    </form>
  }
  @if (hasExpired) {
    <div class="text-danger">Your password token has expired.</div>
  }
</div>
<br /><br />

<div class="text-center">
  <u>Password Requirements</u><br />
  Must be at least 10 characters in Length.<br />
  Cannot match any of the passwords in our list of commonly used passwords.<br />
  (Examples of Commonly Used Passwords: "Password", "Love", "Password123", etc.)<br />
  Cannot contain repeating or sequential characters <br />
  (Examples of Repeating or Sequential Characters: "aaa", "abc", "123", etc.)<br />
</div>
